module.exports = __webpack_public_path__ + "static/ref_1280-315c92490ec5f88b93778a150fa4d631.jpg";